export class UpdateObjectStoreScanMethodRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cdcBackup",
            "baseName": "cdcBackup",
            "type": "UpdateObjectStoreScanMethodSetting",
            "format": ""
        },
        {
            "name": "inventoryBackup",
            "baseName": "inventoryBackup",
            "type": "UpdateObjectStoreScanMethodSetting",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateObjectStoreScanMethodRequest.attributeTypeMap;
    }
    constructor() {
    }
}
